import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AvailableTemplatesDialogComponent } from '../available-templates-dialog/available-templates-dialog.component';

@Component({
  selector: 'app-templated-input-instructions',
  templateUrl: './templated-input-instructions.component.html',
  styleUrl: './templated-input-instructions.component.scss',
  standalone: false
})
export class TemplatedInputInstructionsComponent {
  constructor(public dialog: MatDialog) {}

  onViewTemplatesClick() {
    this.dialog.open(AvailableTemplatesDialogComponent, {
      width: '1000px',
      data: { templates: '' },
    });
  }
}
